module.exports = __webpack_public_path__ + "static/media/rings.c1f8efbd.jpg";